<template>
  <div class="saveModal" v-show="show">
    <div class="saveModal__texts">
      <div class="saveModal__text">壁面に描きこみます<span class="endLetter">。</span><br>よろしいですか？</div>
      <div class="saveModal__text">Do you want to draw it on the wall?</div>
    </div>
    <div class="saveModal__ok buttonPrimary" @click="ok">OK</div>
    <div class="saveModal__cancel buttonMini" @click="cancel">cancel</div>
  </div>

</template>

<script>
import * as types from "../../events/DrawEventType";
import * as tabletTypes from "../../store/modules/tablet/types";
import { DrawEvent } from "../../events/DrawEvent";
export default {
  name: "TabletSaveModal",
  computed: {
    show() {
      return this.$store.state.tablet.modal;
    }
  },
  methods: {
    ok() {
      DrawEvent.emit(types.PUBLISH);
    },
    cancel() {
      this.$store.dispatch(
        tabletTypes.namespace + tabletTypes.SET_MODAL,
        false
      );
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"

.saveModal
    background-color: rgba(0, 0, 0, 0.6)
    z-index: $z_save_modal
    position: fixed
    @include fit
    @include flexCenter
    flex-wrap: wrap
    flex-direction: column
    text-align: center
    > div
        margin-bottom: 2em
.saveModal__texts
  margin-bottom: 86px
.saveModal__text
  //@include vw(22)
  font-size: 22px
  margin-bottom: 37px
.buttonPrimary
  //@include vw(25)
  font-size: 25px
  height: 60px
  border-radius: 60px
  width: 187px

.buttonMini
  font-size: 16px

</style>
